<template>
  <div class="c-greeks">
    <b-table striped hover dark head-variant="dark" small :fields="fields" :items="items" :aria-label="i18n('label')">
      <template v-slot:head(title)="data">
        {{ i18n(data.label) }}
      </template>
      <template v-slot:cell(title)="data">
        {{ i18n(data.item.title) }}
      </template>
      <template v-slot:cell(value)="data">
        {{ formatter(data.value) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { isOption, isBuy } from '@/utils/optionChainServices/legService';

export default {
  name: 'c-greeks',
  props: {
    legs: {
      type: Object
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'label'
        },
        {
          key: 'value',
          label: ''
        }
      ],
      items: [
        {
          title: 'delta',
          value: '-'
        },
        {
          title: 'gamma',
          value: '-'
        },
        {
          title: 'theta',
          value: '-'
        },
        {
          title: 'vega',
          value: '-'
        },
        {
          title: 'rho',
          value: '-'
        }
      ]
    };
  },
  watch: {
    legs: {
      handler: 'handleLegs',
      deep: true
    }
  },
  methods: {
    i18n(key) {
      return this.$t(`white-label.widgets.optionChain.greeks.${key}`);
    },
    handleLegs() {
      if (this.legs.first || this.legs.second) {
        const greeks = this.getSummedGreeksFromLegs();
        this.setItemsFromGreeks(greeks);
      } else {
        this.resetGreeks();
      }
    },
    getSummedGreeksFromLegs: function() {
      const result = { _DELTA: '-', _GAMMA: '-', _THETA: '-', _VEGA: '-', _RHO: '-' };

      Object.keys(this.legs).forEach(leg => {
        // If leg exists and is an OPTION -> add its Greeks
        if (this.legs[leg] && isOption(this.legs[leg])) {
          const _leg = this.legs[leg];
          const fak = isBuy(_leg) ? 1 : -1;

          Object.keys(result).forEach(greekFid => {
            const greek = isOption(_leg) ? _leg.option[greekFid] : 1;

            if (result[greekFid] === '-') {
              result[greekFid] = 0;
            }

            result[greekFid] += parseFloat(greek * _leg.quantity * fak);
          });
        }
      });

      return [result['_DELTA'], result['_GAMMA'], result['_THETA'], result['_VEGA'], result['_RHO']];
    },
    setItemsFromGreeks(greeks) {
      this.items.forEach((item, index) => {
        item.value =
          greeks[index] !== '-' && !isNaN(parseFloat(greeks[index])) ? parseFloat(greeks[index]).toFixed(3) : '-';
      });
    },
    resetGreeks() {
      this.setItemsFromGreeks(['-', '-', '-', '-', '-']);
    },
    formatter(value) {
      if (value === '-') return value;
      return this.$n(+value, {
        style: 'decimal',
        minimumFractionDigits: 3,
        maximumFractionDigits: 4
      });
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-greeks';
</style>
